import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';
import { CreateEmployeeContractForm } from '@/components/features/employee/createEmployeeContractForm';
import { useEmployeeContractCreate } from '@/hooks/employee/useEmployeeContractCreate';
import { useTranslation } from '@/i18n';
import { ROUTE_DEFINITIONS } from '@/routes';
import { buildEmployeeFullName, formatEmployeeIdentity } from '@/utils';


export const EmployeeContractCreate: React.FC = () => {
  const { t: translate } = useTranslation();
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    isLoading,
    creating,
    employeeProfile,
    handleCancel,
    handleCreate,
    contractStatusOptions,
    contractTypeOptions,
    contractModalityOptions,
    companyOptions,
    areaOptions,
    positionOptions,
    costCenterOptions,
    unionOptions,
    form,
  } = useEmployeeContractCreate(employeeId ? Number(employeeId) : undefined);

  // Build backTo URL with employeeId query parameter
  const backToUrl = useMemo(() => {
    const baseUrl = ROUTE_DEFINITIONS.EMPLEADO_CONTRATOS.path;
    return employeeId ? `${baseUrl}?employeeId=${employeeId}` : baseUrl;
  }, [employeeId]);
  
  // Build dynamic title with employee name and RUT
  const dynamicTitle = useMemo(() => {
    const identity = formatEmployeeIdentity(
      buildEmployeeFullName(employeeProfile ?? {}),
      employeeProfile?.rutFull,
    );
    return identity ? translate('employee:breadcrumb.contractCreate', { identity }) : undefined;
  }, [employeeProfile, translate]);

  return (
    <PageLayout backTo={backToUrl} dynamicTitle={dynamicTitle} isLoading={isLoading}>
      <CreateEmployeeContractForm
        contractForm={form}
        contractStatusOptions={contractStatusOptions}
        contractTypeOptions={contractTypeOptions}
        contractModalityOptions={contractModalityOptions}
        companyOptions={companyOptions}
        areaOptions={areaOptions}
        positionOptions={positionOptions}
        costCenterOptions={costCenterOptions}
        unionOptions={unionOptions}
        creating={creating}
        onCancel={handleCancel}
        onSave={handleCreate}
      />
    </PageLayout>
  );
};

export default EmployeeContractCreate;
